<template>
<div class="communicate-wrap">
  <div class="communicate" :class="visible ? 'communicate-small' : ''">
    <div class="head">
        <span class="tlt">{{ $t( 'design.communicate.records' ) || '案例沟通记录'}}</span>
        <div v-if="platform !== 'dentalx' && platform !== 'designerService'">
            <div v-show="orderStatus === 'pause' && !visible && lastOrderState !== 'waitCheck'">
                <XlButton class="btn" @click="onConfirm">{{$t('design.orderDetail.requirementConfirmed') || "需求已确认"}}</XlButton>
                <XlButton @click="onAdd">{{$t('design.orderDetail.dataSupplementation') || "数据补充"}}</XlButton>
            </div>
        </div>
    </div>
    <xl-scrollbar ref="scrollbarRef">
        <div class="content">
            <div v-for="(item, index) in msgList" :key="index" class="msg-item" :class="item.isOwn ? 'msg-owner' : 'msg-other' ">
                <div class="item" :class="item.isOwn ? 'item-owner' : ''">
                    <div class="avatar"><img :src="item.avatarUrl || defaultAvatar" alt=""></div>
                    <div class="info">
                        <!-- 名称：sys: 先临设计中心 -->
                        <div class="title"><span>{{ item.publisherName === 'sys' ? ($t('design.communicate.sys') || '先临设计中心') : item.publisherName  }}</span><span>{{ item.createOn }}</span></div>
                        <div class="msg msg-file" v-if="item.msgType === 'file'">
                            <i class="i-file"></i>
                            <span class="text">{{item.file?.name}}</span>
                            <div v-if="item.file?.status === 'uploading'" class="file-progress">
                                <xl-progress type="circle" :stroke-width="2" :width="13" :percentage="item.file?.percentage"></xl-progress>
                            </div>
                            <div v-else-if="item.file?.status === 'success'" class="file-success"></div>
                            <div v-else :class="item.isOwn ? 'file-success' : 'file-download'" @click="onDownload(item)"></div>
                        </div>
                        <div class="msg msg-image" v-else-if="item.msgType === 'image'">
                            <xl-image :src="item.file?.url" fit="contain" :preview-teleported="true" :preview-src-list="[{url:item.file?.url}]"></xl-image>
                        </div>
                        <div class="msg" :class="(item.isOrderStatus && item.orderStatusValue !== 'pauseMessage') ? 'order-msg' : ''" v-else>{{ item.content }}</div>
                    </div>
                </div>
            </div>
        </div>
    </xl-scrollbar>
    <div class="chat">
        <div class="file" :class="uploadDisabled ? 'file-dis' : ''">
            <xl-upload2 
                :disabled="uploadDisabled"
                category="dentalComment" 
                :isPrivate="false"
                ref="uploadRef"
                isBigFile
                :maxSize="100"
                :show-file-list="false"
                :outOfSizeTip="$t('design.case.outOffSizeTip', { size: 100 })"
                v-model:file-list="fileList"
                :before-upload="beforeUpload"
                @success="uploadedsuccess" 
                @error="handleUploadErr"
                >
                <template #default>
                    <!-- <i></i> -->
                    <div class="upload-icon">
                        <img src="../../../assets/image/upfile.svg" alt="">
                    </div>
                </template>
            </xl-upload2>
        </div>
        <div class="text">
            <xl-input type="textarea" v-model="descValue" :placeholder="$t('design.orderDetail.inputDescribe') || '请输入沟通信息'" maxlength="2000"></xl-input>
        </div>
        <div class="footer">
            <xl-button type="primary" @click="onSendMsg">{{$t('design.send') || '发送'}}</xl-button>
        </div>
    </div>
  </div>
  <add-case-file v-model="visible" @success="onReAdd" :info="info" :platform="platform"></add-case-file>
</div>
</template>

<script setup>
// 案例沟通
import { XlButton, XlInput, XlScrollbar, XlUpload2, XlProgress, XlImage, XlMessage } from '@shining3d/ui-components';
import { ref, nextTick, onMounted, computed, defineProps, inject } from 'vue';
import $moment from 'moment';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import router from '@/router';
import { useStore } from "vuex";
import _get from 'lodash/get';
import store from '@/store';
import { $getLocalStorage } from '@shining3d/common-module/utils/index.js';
import { $getCdnUrl, $convertUTCDateToLocalDate } from '../../../utils/common.js';
import Bus from '../../../utils/bus.js';
import addCaseFile from './addCaseFile.vue';
// import Api from '../../../api/orderDetail/index.js';
import adminAvatar from '../../../assets/image/adminAvatar.png';
import defaultAvatar from '../../../assets/image/avatar.png';
import { orderStatusMap } from '../../../common/orderConst.js';
// import commonApi from '@/api/common';

import { orderDetail } from '../../../api/orderDetail/index.js';
const Api = orderDetail[props.platform]
const { $t } = useLang("@shining3d/xl-design-order");
const { $t: $tapp } = useLang("@shining3d/app");
const $store = useStore();

const props = defineProps({
  platform: {
    type: String,
    default: 'dental'
  },
  info: {
    type: Object,
    default: () => ({})
  }
})
const getDetail = inject('getDetail');
const _id = _get( $store, 'state.factorySelect.id', '' );
const route = router.currentRoute.value;
const orderID = computed(() => _get( route, 'params.id', '' ));

const scrollbarRef = ref( null );
const descValue = ref( '' );
const orderStatus = ref( '' ); // 订单状态： pause 暂停中显示补充文件按钮，其余不展示。
const lastOrderState = ref(''); //订单lastOrderState=waitCheck,不显示补充文件和确认需求按钮

const visible = ref( false );
const fileList = ref([]);
const uploadRef = ref( null );

const userInfo = computed(() => $getLocalStorage( 'userInfo' ) || {});
const avatarDfsID = computed(() => _get( $store, 'state.userInfo.avatarDfsID' ) || '');
const avatarBucket = computed(() => _get( $store, 'state.userInfo.avatarBucket' ) || '');

const ownAvatarUrl = computed(() => {
    if ( avatarDfsID.value && avatarBucket.value ) {
        return $getCdnUrl({ bucket: avatarBucket.value, dfsID: avatarDfsID.value })
    } else {
        return defaultAvatar
    }
});
/** 
消息格式字段：
    msgType 类型：默认普通文字信息展示，file: 展示下载文件名称， image：图片类型
    isOrderStatus：true. 是否是订单状态变更信息。（文字背景会不同）
    isOwn: true 消息是否是当前登录的用户
    publisherName: 'sys' , 发布用户名是 sys 时，会展示成 先临设计服务中心
**/
const msgList = ref([]);

const scrollToButtom = () => {
    setTimeout(() => {
        const ele = scrollbarRef.value?.wrap$;
        const scrollHeight = ele.scrollHeight;
        scrollbarRef.value.setScrollTop( scrollHeight );
    }, 300);
};

const onSendMsg = () => {
    if ( !descValue.value ) {
        return;
    }
    const data = {
        avatarDfsID: avatarDfsID.value,
        avatarBucket: avatarBucket.value,
        publisherName: userInfo.value.nickName,
        publisherID: userInfo.value.userID,
        content: descValue.value,
        isOwn: true,
        avatarUrl: ownAvatarUrl.value,
        createOn: formatTime( $moment.utc().format() ),
        orgID: _id,
        orderID: orderID.value,
        bucket: '',
        dfsID: '',
        cloud: ''
    };

    Api.addComment( data ).then(( res ) => {
        if ( res && res.status === 'success' ) {
            // todo: 重新拉取消息
            // msgList.value.push( data );
            getCommentList();
            descValue.value = '';
            scrollToButtom();
        } 
    });
};

// 需求已确认
const onConfirm = () => {
    const params = {
        orgID: _id,
        orderID: orderID.value,
    };
    Api.supplyOrderFiles( params ).then(( res ) => {
        if ( res && res.status === 'success' ) {
            getCommentList();
            scrollToButtom();
            getDetail();

            Bus.$emit( 'updateOrderList' )
        }
    });
};

const onAdd = () => {
    visible.value = true;
};

const uploadDisabled = ref( false );
const fileIndex = ref();
const beforeUpload = ( rawFile ) => {
    uploadDisabled.value = true;
    // 是否代表系统发送消息
    const isSys = ['dentalx', 'dentalxDesign'].includes(props.platform)
    msgList.value.push({
        publisherName: isSys ? $t('design.communicate.sys') : userInfo.value.nickName,
        isOwn: true, // 是否是自己
        msgType: 'file',
        avatarUrl:isSys ? adminAvatar : ownAvatarUrl,
        file: fileList.value?.[fileList.value.length - 1],
        createOn: formatTime( $moment.utc().format() )
    });
    // 记录一下文件的消息位置
    fileIndex.value = msgList.value.length - 1;
    scrollToButtom();
    return true;
};

// 上传组件错误处理
let csrfTokenRefreshing = false;
const handleUploadErr = async ({ error, uploadFile }) => { 
    uploadDisabled.value = false;
    msgList.value = msgList.value.filter((item, index) => index !== fileIndex.value);
    nextTick(async () => {
        if ( error?.result === 'csrfTokenErr' ) {
            if ( !csrfTokenRefreshing ) { // 多文件上传，设置标识，直接删除（刷新）csrfToken，重新上传。
                csrfTokenRefreshing = true;
                // const result = await commonApi.cookies({ cookies: [{ name: 'csrfToken', action: 'delete' }] });
                csrfTokenRefreshing = false;
                if ( result.status === 'success' ) {
                    fileList.value.push({ ...uploadFile, status: 'ready' }); // 错误回调时文件已被删除，通过push重新加入到文件队列中
                    nextTick(() => {
                        uploadRef.value.submit();
                    });
                }
            } else {
                fileList.value.push({ ...uploadFile, status: 'ready' });
            }
        } else {
            XlMessage({ type: 'error', message: $t( 'design.dataAudit.uploadErr' ) });
        }
    });
};

// 文件上传 cdn 成功，发送消息记录
const uploadedsuccess = ( data ) => {
    uploadDisabled.value = false;
    const res = data.response;
    const { bucket, category, endpoint, fileLength, fileName, cloud, dfsID } = res;
    const params = {
        bucket,
        category,
        endpoint,
        fileLength,
        fileName,
        cloud,
        dfsID,
        avatarDfsID: avatarDfsID.value,
        avatarBucket: avatarBucket.value,
        publisherName: userInfo.value.nickName,
        publisherID: userInfo.value.userID,
        orderID: orderID.value,
        orgID: _id
    };
    Api.addComment( params ).then(() => {
        getCommentList();
    }).catch(() => {
        // todo: 失败
    })
};

const onDownload = ( item ) => {
    window.open( item.file?.url );
};

// 补充文件成功，更改订单状态
const onReAdd = () => {
    orderStatus.value = 'waitRecover';
    // todo: 重新拉取下消息列表
    getCommentList();
    Bus.$emit( 'updateOrderList' );
};

const formatTime = ( time ) => {
    let formatTime = $convertUTCDateToLocalDate( time, 'MM-DD HH:mm' );
    const day = $convertUTCDateToLocalDate( time, 'YYYY-MM-DD' );
    const today = $convertUTCDateToLocalDate( $moment.utc().format(), 'YYYY-MM-DD' );
    if ( day === today ) {
        formatTime = $t( 'design.today' ) + ' ' + $convertUTCDateToLocalDate( time, 'HH:mm' );
    }
    return formatTime;
};

const getCommentList = ( from = '') => {
    Api.getListComments({
        orgID: _id,
        orderID: orderID.value
    }).then(( res ) => {
        if ( res && res.status === 'success' ) {
            const list = res.result?.comments || [];
            orderStatus.value = res.result?.orderState;
            lastOrderState.value = res.result?.lastOrderState;
            msgList.value = list.map(item => {
                let msgType = '', file = {};
                if ( item.dfsID ) {
                    // 文件类型
                    const url = $getCdnUrl({ bucket: item.bucket, dfsID: item.dfsID });
                    file = {
                        name: item.fileName,
                        url,
                    };
                    if ( /\.(png|jpe?g)/.test( item.fileName )) {
                        msgType = 'image';       
                    } else {
                        msgType = 'file';
                    }
                }
                const isOwn = item.publisherID === userInfo.value.userID || (['dentalx', 'dentalxDesign'].includes(props.platform) && !item.publisherID );
                
                let avatarUrl = item.publisherName === 'sys' ? adminAvatar : defaultAvatar ;
                if ( item.publisherName !== 'sys' && item.avatarBucket && item.avatarDfsID ) {
                    avatarUrl = $getCdnUrl({ bucket: item.avatarBucket, dfsID: item.avatarDfsID });
                }
                let orderStatusValue = item.isOrderStatus ? item.content : '';
                // 订单状态文字处理
                if ( item.isOrderStatus ) {
                    if ( orderStatusValue !== 'pauseMessage' ) {
                        if (props.platform === 'designerService' && orderStatusValue === 'designComplete') {
                            orderStatusValue = 'waitSettle'
                        }
                        item.content = $t( 'design.order.statusChange', {
                            status: $t( `design.order.${orderStatusValue}`)
                        });
                    } else {
                        item.content =  $t( `design.order.${orderStatusValue}`);
                    }
                }
                switch (item.commentType) {
                    case 'adminRejectReason':
                        item.content = $t('design.order.adminRejectReason') + ': ' + (item.content || '').split(',').map(item =>  $tapp(`design.refuseReason.${item}`)).join('、');
                        break;
                    case 'adminRejectNote':
                        item.content = $t('design.order.adminRejectNote') + ': ' + item.content;
                        break
                    case 'designerRefuseReason':
                        item.content = $t('design.order.designerRefuseReason') + ': ' + (item.content || '').split(',').map(item =>  $tapp(`design.refuseReason.${item}`)).join('、');
                        break;
                    case 'designerRefuseNote':
                        item.content = $t('design.order.designerRefuseNote') + ': ' + item.content;
                        break;
                    default:
                        break;
                }
                return {
                    ...item,
                    isOwn,
                    createOn: formatTime( item.createOn ),
                    avatarUrl,
                    msgType,
                    file,
                    orderStatusValue
                }
            });
            scrollToButtom();

            if ( from === 'refresh' ) {
                XlMessage({
                    type: 'success',
                    message: $t('design.refreshSuccess') || '刷新成功'
                });
            }
        } else {
            lastOrderState.value = '';
        }
    });
};

const refresh = () => {
    if ( uploadDisabled.value ) {
        XlMessage({ type: 'warning', message: $t('design.file.uploading') || '文件正在上传中，请稍后' });
        return;
    } 
    getCommentList( 'refresh' );
}

onMounted(() => {
    getCommentList();
});

defineExpose({ refresh })
</script>

<style lang="scss" scoped>
.communicate-wrap {
    padding: 16px;
    box-sizing: border-box;
    height: 100%;
}
.communicate {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #F7F8FA;
    border-radius: 6px;
    transition: width 0.3s;
    .head {
        display: flex;
        height: 54px;
        margin: 0 16px;
        border-bottom: 1px solid #E0E4EA;
        align-items: center;
        justify-content: space-between;
        .tlt {
            font-size: 14px;
            color: #2C364E;
            font-weight: 500;
        }
        :deep(.xl-button) {
            height: 32px;
            line-height: 32px;
            &:last-child {
                margin-left: 16px;
            }
        }
    }
    :deep(.el-scrollbar) {
        flex: 1;
    }
    .content {
        height: 100%;
        margin: 0 16px;
        box-sizing: border-box;
        padding-top: 16px;
        // overflow-y: auto;
        .msg-item {
            display: flex;
            flex-direction: row;
            margin-bottom: 24px;
            .avatar {
                width: 44px;
                height: 44px;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }
            .item {
                display: flex;
                flex-direction: inherit;
                .avatar {
                    margin-right: 8px;
                }
                .info {
                    flex: 1;
                }
                .title {
                    font-size: 12px;
                    color: #737E99;
                    line-height: 18px;
                    margin-bottom: 4px;
                    span {
                        &:first-child {
                            padding-right: 8px;
                        }
                    }
                }
                .msg {
                    font-family: aliFontT65,aliFontO65;
                    padding: 12px;
                    background: #fff;
                    font-size: 14px;
                    // color: #737E99;
                    color: #2C364E;
                    border-radius: 6px;
                    overflow: hidden;
                    word-wrap: break-word;
                }
                .order-msg {
                    background: linear-gradient(90deg, #FFFFFF 4.43%, #F1F4FF 47.43%, #FFEDFE 100%);
                }
                .msg-file {
                    display: flex;
                    align-items: center;
                    min-width: 250px;
                }
                .msg-image {
                    max-height: 165px;
                    max-width: 274px;
                    box-sizing: border-box;
                    :deep(.xl-image) {
                        max-width: 250px;
                        max-height: 141px;
                    }
                }
                .i-file {
                    width: 16px;
                    height: 16px;
                    background: url('../../../assets/image/report.svg');
                    margin-right: 8px;
                }
                .text {
                    flex: 1;
                    margin-right: 106px;
                    color: #42526E;
                }
                .file-progress {
                    width: 16px;
                    height: 16px;
                    display: flex;
                }
                .file-success {
                    width: 16px;
                    height: 16px;
                    background: url('../../../assets/image/success.svg');
                    background-size: contain;
                }
                .file-download {
                    width: 16px;
                    height: 16px;
                    background: url('../../../assets/image/download.svg');
                    background-size: contain;
                    // margin-left: 106px;
                    cursor: pointer;
                }
            }
            .item-owner {
                .avatar {
                    margin-right: 0px;
                    margin-left: 8px;
                }
                .title {
                    display: flex;
                    flex-direction: row-reverse;
                    span {
                        &:first-child {
                            padding-left: 8px;
                            padding-right: 0px;
                        }
                    }

                }
            }
            
        }
        .msg-owner {
            flex-direction: row-reverse;
        }
    }
    .chat {
        display: flex;
        flex-direction: column;
        height: 142px;
        box-sizing: border-box;
        margin: 0 16px;
        padding-top: 10px;
        border-top: 1px solid #E0E4EA;
        .file {
            i {
                background: url('../../../assets/image/upfile.svg');
                display: inline-block;
                background-size: contain;
                width: 28px;
                height: 28px;
                cursor: pointer;
            }
            .upload-icon{
                width: 28px;
                height: 28px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                padding: 4px;
                box-sizing: border-box;
                cursor: pointer;
                &:hover{
                    background: #E9EBEF;
                }
            }
        }
        .file-dis {
            .upload-icon {
                opacity: 0.6;
                cursor: not-allowed;
            }   
        }
        .text {
            flex: 1;
            :deep(.el-textarea) {
                height: 100%;
                border: none !important;
                background-color: none !important;
                .el-textarea__inner {
                    height: 100%;
                    &::placeholder {
                        color: #A5ACBE !important;
                    }
                }
            }
            :deep(.el-textarea__inner) {
                padding: 0px !important;
                outline: none !important;
                resize: none !important;
                background: transparent !important;
                border: none !important;
                box-shadow: none !important;
                &:focus {
                    box-shadow: none !important;
                }
                &:hover {
                    background: transparent !important;
                }
            }
        }
        .footer {
            display: flex;
            padding-bottom: 16px;
            flex-direction: row-reverse;
        }
    }
}
.communicate-small {
    width: calc(100% - 408px);
}
</style>